import React, { useEffect, useRef } from "react";
import { Window } from "@progress/kendo-react-dialogs";
import CustomDropdown from "src/components/customDropdown";
import "./index.scss";
import { TextArea } from "@progress/kendo-react-inputs";
import { getUserCredential } from "src/lib/cookies";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getCompAdmin } from "./service/getCompAdmin";
import { getQueryTypes } from "./service/getQueryTypes";
import { createChat } from "./service/createChat";
import { setNewMessage } from "src/redux/actions/setting-actions";
import { errStatusHandler } from "src/api-setup/api-helper";
import { useHistory } from "react-router-dom";

const NewMessage = (props) => {
  const dispatch = useDispatch();
  const cookiesData = getUserCredential();
  const history = useHistory();
  const { userStatusData } = useSelector((state) => state.mobileRoleReducer?.mobileRoleData || {}, shallowEqual);

  const [stageChange, setStateChange] = React.useState("DEFAULT");
  const [modal, setModal] = React.useState(true);
  const [approverList, setApproverList] = React.useState([]);
  const [formFields, setFormFields] = React.useState({
    providerList: { id: "", text: "" },
    queryList: { id: "", text: "" },
    approver: { id: "", text: "" },
  });
  const [roleData, setRoleData] = React.useState([]);
  const [roleFields, setRoleFields] = React.useState([]);
  const [approverFields, setApproverFields] = React.useState([]);
  const [inputText, setInputText] = React.useState("");
  const [queryData, setQueryData] = React.useState([]);
  const [queryFields, setQueryFields] = React.useState([]);
  const roleRef = useRef(null);
  const queryRef = useRef(null);
  const [loadingState, setLoadingState] = React.useState({
    provider: false,
    approver: false,
    queryType: false,
  });

  const ModalTitle = () => <span>New Message</span>;

  const handleStageChange = (e) => {
    setStateChange(e.state);
    setModal(e.state === "DEFAULT");
  };

  const fetchProviderList = async () => {
    try {
      setLoadingState((prev) => ({ ...prev, provider: true, approver: true }));
      const [providerData] = await Promise.all([
        getCompAdmin(cookiesData, dispatch),
        new Promise((resolve) => setTimeout(resolve, 500)),
      ]);
      const updatedApproverList = providerData
        ?.filter((item) => item.user_role === "approver")
        .map((item) => ({
          ...item,
          text: item.user_name,
          id: item.user_key,
        }));

      const updatedProviderList = providerData
        ?.filter((item) => item.user_role === "provider")
        .map((item) => ({
          ...item,
          text: item.user_name,
          id: item.user_key,
        }));

      setApproverList(updatedApproverList);
      setRoleData(updatedProviderList);
    } catch (error) {
      console.error("Error fetching providers:", error);
    } finally {
      setLoadingState((prev) => ({ ...prev, provider: false, approver: false }));
    }
  };

  const handleDropdownChange = (selectedItem, name) => {
    setFormFields((prev) => {
      if (name === "providerList") {
        return {
          ...prev,
          providerList: selectedItem ? { id: selectedItem.id, text: selectedItem.text } : { id: "", text: "" },
          approver: { id: "", text: "" },
          queryList: { id: "", text: "" },
        };
      }

      if (name === "approver") {
        return {
          ...prev,
          approver: selectedItem ? { id: selectedItem.id, text: selectedItem.text } : { id: "", text: "" },
          providerList: { id: "", text: "" },
          queryList: { id: "", text: "" },
        };
      }

      if (name === "queryList") {
        return {
          ...prev,
          queryList: selectedItem ? { id: selectedItem.id, text: selectedItem.text } : { id: "", text: "" },
        };
      }

      return prev;
    });
  };

  const handleSubmit = async (formFields) => {
    try {
      const isAdmin = userStatusData?.[0]?.pay_request_tracker_read_access === 1;

      if (!isAdmin) {
        if (!formFields?.queryList?.id) {
          dispatch(
            setNewMessage({
              message: "Please select a query type.",
              type: "Error",
              show: true,
            })
          );
          return;
        }

        if (!inputText?.trim()) {
          dispatch(
            setNewMessage({
              message: "Message is required.",
              type: "Error",
              show: true,
            })
          );
          return;
        }
      } else {
        if (!formFields?.providerList?.id && !formFields?.approver?.id) {
          dispatch(
            setNewMessage({
              message: "Please select a provider or approver",
              type: "Error",
              show: true,
            })
          );
          return;
        }

        if (!formFields?.queryList?.id) {
          dispatch(
            setNewMessage({
              message: "Please select a query type.",
              type: "Error",
              show: true,
            })
          );
          return;
        }

        if (!inputText?.trim()) {
          dispatch(
            setNewMessage({
              message: "Message is required.",
              type: "Error",
              show: true,
            })
          );
          return;
        }
      }
      props.setIsLoadChat(true);
      props.setIsLoadStatus(true);
      const providerId = formFields?.approver?.id ? formFields?.approver?.id : formFields?.providerList?.id;
      const userKeyId = isAdmin ? providerId : cookiesData?.out_user_id;
      props.onClose();

      const [chatCreated] = await Promise.all([
        createChat(cookiesData, dispatch, userKeyId, formFields?.queryList?.id, inputText),
        new Promise((resolve) => setTimeout(resolve, 2000)),
      ]);
      props.setIsLoadStatus(false);
      if (chatCreated?.status) {
        if (chatCreated?.data?.out_parameters?.out_error_msg !== "") {
          dispatch(
            setNewMessage({
              message: chatCreated?.data?.out_parameters?.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(chatCreated, history, dispatch);
          setTimeout(() => {
            props?.messagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
          }, 300);
        } else {
          setInputText("");
          setFormFields({
            providerList: { id: "", text: "" },
            queryList: { id: "", text: "" },
            approver: { id: "", text: "" },
          });
          props.onChatCreated();
          props.setAllMessages([]);
          props.setSelectedTab(props.statusTabs[0]);
          setTimeout(() => {
            props?.messagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
          }, 300);
        }
      }
      props.setIsLoadChat(false);
    } catch (error) {
      props.setIsLoadStatus(false);
      props.setIsLoadChat(false);
      console.error("Error in handleSubmit:", error);
    }
  };

  useEffect(() => {
    const fetchQueryTypes = async () => {
      const providerId = formFields?.approver?.id ? formFields?.approver?.id : formFields?.providerList?.id;
      const queryId = userStatusData?.[0]?.user_role?.[0] === "ADMIN" ? providerId : cookiesData?.out_user_id;
      if (queryId) {
        try {
          setLoadingState((prev) => ({ ...prev, queryType: true }));
          const [queryListRes] = await Promise.all([
            getQueryTypes(cookiesData, dispatch, queryId),
            new Promise((resolve) => setTimeout(resolve, 500)),
          ]);
          const updatedQueryList = queryListRes?.map((item) => ({
            ...item,
            text: item?.query_type,
            id: item?.conversation_query_type_mstr_key,
          }));

          setQueryData(updatedQueryList);
        } catch (error) {
          console.error("Error fetching query types:", error);
        } finally {
          setLoadingState((prev) => ({ ...prev, queryType: false }));
        }
      }
    };

    fetchQueryTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formFields.providerList?.id, formFields.approver?.id]);

  useEffect(() => {
    if (userStatusData?.[0]?.user_role?.[0] === "ADMIN" || userStatusData?.[0]?.pay_request_tracker_read_access === 1
    ) {
      fetchProviderList();
    }
  }, []);


  return (
    <Window
      title={<ModalTitle />}
      onClose={props.onClose}
      width={500}
      resizable={false}
      stage={stageChange}
      onStageChange={handleStageChange}
      modal={modal}
      top={150}
      className="auto-height-window"
    >
      <div className="window-container">
        {(userStatusData?.[0]?.user_role?.[0] === "ADMIN" ||
          userStatusData?.[0]?.pay_request_tracker_read_access === 1) && (
          <>
            <div className="window-label">Select Provider*</div>
            <CustomDropdown
              name="providerList"
              dataList={roleData}
              data={roleFields.length || roleFields === null ? roleFields : []}
              textField="text"
              dataItemKey="id"
              valueData={roleData.find((c) => c.id === formFields.providerList?.id) || null}
              filterable={true}
              onChange={(selectedItem, name) => handleDropdownChange(selectedItem, name)}
              onFilterChange={(filteredData) => {
                setRoleFields(filteredData.length ? filteredData : []);
              }}
              onOpen={() => setRoleFields(roleData)}
              appendTo={roleRef.current}
              loading={loadingState.provider}
            />

            <div className="or-divider">
              <span>OR</span>
            </div>

            <div className="window-label">Select Approver*</div>
            <CustomDropdown
              placeholder="Choose an Approver"
              name="approver"
              data={approverFields.length || approverFields === null ? approverFields : []}
              dataList={approverList}
              textField="text"
              dataItemKey="id"
              autoClose={false}
              autoBind={true}
              isSelectALl={true}
              valueData={approverList.find((a) => a.id === formFields.approver?.id) || null}
              filterable={true}
              onChange={(selectedItem, name) => handleDropdownChange(selectedItem, name)}
              onFilterChange={(filteredData) => setApproverFields(filteredData.length ? filteredData : [])}
              onOpen={() => setApproverFields(approverList)}
              loading={loadingState.approver}
            />
          </>
        )}

        <div className="window-label">Select Query Type*</div>
        <CustomDropdown
          name="queryList"
          data={queryFields.length || queryFields === null ? queryFields : []}
          dataList={queryData}
          textField="text"
          dataItemKey="id"
          autoClose={false}
          autoBind={true}
          isSelectALl={true}
          valueData={queryData.find((c) => c.id === formFields.queryList?.id) || null}
          filterable={true}
          onChange={(selectedItem, name) => handleDropdownChange(selectedItem, name)}
          onFilterChange={(filteredData) => setQueryFields(filteredData.length ? filteredData : [])} // empty if no match
          onOpen={() => setQueryFields(queryData)} // reset on open
          appendTo={queryRef.current}
          disabled={
            userStatusData?.[0]?.user_role?.[0] === "ADMIN"
              ? !formFields.providerList?.id && !formFields.approver?.id
              : false
          }
          loading={loadingState.queryType}
        />

        <div className="window-label">Write A Message*</div>
        <TextArea
          className="window-input"
          value={inputText}
          onChange={(e) => setInputText(e.value)}
          placeholder="Type Your Message..."
          rows={5}
        />

        <div className="window-btn-container">
          <button onClick={props.onClose} className="window-cancel-btn">
            Cancel
          </button>
          <span
            className={`window-send-btn ${formFields.queryList.id === "" || inputText.trim() === "" ? "disabled" : ""}`}
            onClick={() => handleSubmit(formFields)}
          >
            <span className="window-send-text">Send</span>
          </span>
        </div>
      </div>
    </Window>
  );
};

export default React.memo(NewMessage);
